var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "currentColor",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 8.5h-.592l-.21-.203a4.88 4.88 0 0 0 1.11-4.005C9.58 2.207 7.84.542 5.74.287A4.88 4.88 0 0 0 .287 5.74c.255 2.1 1.92 3.84 4.006 4.192a4.88 4.88 0 0 0 4.004-1.11l.203.21v.593l3.188 3.188a.79.79 0 0 0 1.117 0 .79.79 0 0 0 0-1.118zm-4.5 0A3.37 3.37 0 0 1 1.75 5.125 3.37 3.37 0 0 1 5.125 1.75 3.37 3.37 0 0 1 8.5 5.125 3.37 3.37 0 0 1 5.125 8.5"
  })));
};
export default SvgSearch;